import React, { FC } from 'react';
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'

import {ReactComponent as PlayIcon} from 'assets/images/play.svg'

import styles from './styles.module.scss'

interface IProps {}
export const Play: FC<IProps> = props =>  {
  return (
   <div className={styles.playBox}>
     <PlayIcon className={styles.small}/>
     <PlayIcon className={styles.big}/>
   </div>
  );
}
